export const passThrough =
    <A, B>(f: (a: A) => B) =>
    (a: A): A => {
        f(a)
        return a
    }

export const assertExhaustive = (x: never): never => {
    throw new Error("Assert never - unexpected object: " + x)
}
